// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i8U6h","questions":"styles_questions__QOt8f","footer":"styles_footer___nq9e"};